/* tslint:disable */
/* eslint-disable */
/**
 * IRM.Web.Customer.API
 * 6d75acac-ec29-43a4-9fe0-2808f10c310c Development
 *
 * The version of the OpenAPI document: 2024.05.17.1151
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from "../configuration";
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from "axios";
import globalAxios from "axios";
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
} from "../common";
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  RequestArgs,
  BaseAPI,
  RequiredError,
} from "../base";
// @ts-ignore
import { ApiCreditMemoDRAFTPatchRequest } from "../models";
// @ts-ignore
import { CreditMemoModel } from "../models";
// @ts-ignore
import { CreditMemoModelODataResultCollection } from "../models";
// @ts-ignore
import { FileUriODataResultCollection } from "../models";
/**
 * CreditMemoApi - axios parameter creator
 * @export
 */
export const CreditMemoApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @summary Get document by DocEntry and IsDraft
     * @param {number} docEntry
     * @param {string} dRAFT
     * @param {boolean} [isDraft]
     * @param {string} [$expand] Specifies the related resources to be included in line with retrieved resources. (e.g. $expand&#x3D;DocumentLines)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiCreditMemoDRAFTDocEntryGet: async (
      docEntry: number,
      dRAFT: string,
      isDraft?: boolean,
      $expand?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'docEntry' is not null or undefined
      assertParamExists("apiCreditMemoDRAFTDocEntryGet", "docEntry", docEntry);
      // verify required parameter 'dRAFT' is not null or undefined
      assertParamExists("apiCreditMemoDRAFTDocEntryGet", "dRAFT", dRAFT);
      const localVarPath = `/api/CreditMemo/{DRAFT}/{DocEntry}`
        .replace(`{${"DocEntry"}}`, encodeURIComponent(String(docEntry)))
        .replace(`{${"DRAFT"}}`, encodeURIComponent(String(dRAFT)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKeyAuth required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Api-Key",
        configuration
      );

      if (isDraft !== undefined) {
        localVarQueryParameter["IsDraft"] = isDraft;
      }

      if ($expand !== undefined) {
        localVarQueryParameter["$expand"] = $expand;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Default action to acquire list of documents by IsDraft
     * @param {string} dRAFT
     * @param {boolean} [isDraft]
     * @param {string} [$top] The max number of records. (e.g. $top&#x3D;10)
     * @param {string} [$skip] The number of records to skip. (e.g. $skip&#x3D;5)
     * @param {string} [$filter] A function that must evaluate to true for a record to be returned. (e.g. $filter&#x3D;CustomerName eq \&#39;bob\&#39;)
     * @param {string} [$orderby] Determines what values are used to order a collection of records. (e.g. $orderby&#x3D;Address1_Country,Address1_City desc)
     * @param {string} [$expand] Specifies the related resources to be included in line with retrieved resources. (e.g. $expand&#x3D;DocumentLines)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiCreditMemoDRAFTGet: async (
      dRAFT: string,
      isDraft?: boolean,
      $top?: string,
      $skip?: string,
      $filter?: string,
      $orderby?: string,
      $expand?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'dRAFT' is not null or undefined
      assertParamExists("apiCreditMemoDRAFTGet", "dRAFT", dRAFT);
      const localVarPath = `/api/CreditMemo/{DRAFT}`.replace(
        `{${"DRAFT"}}`,
        encodeURIComponent(String(dRAFT))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKeyAuth required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Api-Key",
        configuration
      );

      if (isDraft !== undefined) {
        localVarQueryParameter["IsDraft"] = isDraft;
      }

      if ($top !== undefined) {
        localVarQueryParameter["$top"] = $top;
      }

      if ($skip !== undefined) {
        localVarQueryParameter["$skip"] = $skip;
      }

      if ($filter !== undefined) {
        localVarQueryParameter["$filter"] = $filter;
      }

      if ($orderby !== undefined) {
        localVarQueryParameter["$orderby"] = $orderby;
      }

      if ($expand !== undefined) {
        localVarQueryParameter["$expand"] = $expand;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} docEntry
     * @param {string} dRAFT
     * @param {boolean} [isDraft]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiCreditMemoDRAFTGetFormIdDocEntryGet: async (
      docEntry: number,
      dRAFT: string,
      isDraft?: boolean,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'docEntry' is not null or undefined
      assertParamExists(
        "apiCreditMemoDRAFTGetFormIdDocEntryGet",
        "docEntry",
        docEntry
      );
      // verify required parameter 'dRAFT' is not null or undefined
      assertParamExists(
        "apiCreditMemoDRAFTGetFormIdDocEntryGet",
        "dRAFT",
        dRAFT
      );
      const localVarPath = `/api/CreditMemo/{DRAFT}/GetFormId/{DocEntry}`
        .replace(`{${"DocEntry"}}`, encodeURIComponent(String(docEntry)))
        .replace(`{${"DRAFT"}}`, encodeURIComponent(String(dRAFT)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKeyAuth required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Api-Key",
        configuration
      );

      if (isDraft !== undefined) {
        localVarQueryParameter["IsDraft"] = isDraft;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary
     * @param {string} dRAFT
     * @param {ApiCreditMemoDRAFTPatchRequest} [apiCreditMemoDRAFTPatchRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiCreditMemoDRAFTPatch: async (
      dRAFT: string,
      apiCreditMemoDRAFTPatchRequest?: ApiCreditMemoDRAFTPatchRequest,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'dRAFT' is not null or undefined
      assertParamExists("apiCreditMemoDRAFTPatch", "dRAFT", dRAFT);
      const localVarPath = `/api/CreditMemo/{DRAFT}`.replace(
        `{${"DRAFT"}}`,
        encodeURIComponent(String(dRAFT))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PATCH",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKeyAuth required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Api-Key",
        configuration
      );

      localVarHeaderParameter["Content-Type"] =
        "application/json;odata.metadata=minimal;odata.streaming=true";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        apiCreditMemoDRAFTPatchRequest,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary
     * @param {string} dRAFT
     * @param {ApiCreditMemoDRAFTPatchRequest} [apiCreditMemoDRAFTPatchRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiCreditMemoDRAFTUpdatePost: async (
      dRAFT: string,
      apiCreditMemoDRAFTPatchRequest?: ApiCreditMemoDRAFTPatchRequest,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'dRAFT' is not null or undefined
      assertParamExists("apiCreditMemoDRAFTUpdatePost", "dRAFT", dRAFT);
      const localVarPath = `/api/CreditMemo/{DRAFT}/Update`.replace(
        `{${"DRAFT"}}`,
        encodeURIComponent(String(dRAFT))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKeyAuth required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Api-Key",
        configuration
      );

      localVarHeaderParameter["Content-Type"] =
        "application/json;odata.metadata=minimal;odata.streaming=true";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        apiCreditMemoDRAFTPatchRequest,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get document by DocEntry and IsDraft
     * @param {number} docEntry
     * @param {boolean} [isDraft]
     * @param {string} [$expand] Specifies the related resources to be included in line with retrieved resources. (e.g. $expand&#x3D;DocumentLines)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiCreditMemoDocEntryGet: async (
      docEntry: number,
      isDraft?: boolean,
      $expand?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'docEntry' is not null or undefined
      assertParamExists("apiCreditMemoDocEntryGet", "docEntry", docEntry);
      const localVarPath = `/api/CreditMemo/{DocEntry}`.replace(
        `{${"DocEntry"}}`,
        encodeURIComponent(String(docEntry))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKeyAuth required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Api-Key",
        configuration
      );

      if (isDraft !== undefined) {
        localVarQueryParameter["IsDraft"] = isDraft;
      }

      if ($expand !== undefined) {
        localVarQueryParameter["$expand"] = $expand;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Default action to acquire list of documents by IsDraft
     * @param {boolean} [isDraft]
     * @param {string} [$top] The max number of records. (e.g. $top&#x3D;10)
     * @param {string} [$skip] The number of records to skip. (e.g. $skip&#x3D;5)
     * @param {string} [$filter] A function that must evaluate to true for a record to be returned. (e.g. $filter&#x3D;CustomerName eq \&#39;bob\&#39;)
     * @param {string} [$orderby] Determines what values are used to order a collection of records. (e.g. $orderby&#x3D;Address1_Country,Address1_City desc)
     * @param {string} [$expand] Specifies the related resources to be included in line with retrieved resources. (e.g. $expand&#x3D;DocumentLines)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiCreditMemoGet: async (
      isDraft?: boolean,
      $top?: string,
      $skip?: string,
      $filter?: string,
      $orderby?: string,
      $expand?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/CreditMemo`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKeyAuth required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Api-Key",
        configuration
      );

      if (isDraft !== undefined) {
        localVarQueryParameter["IsDraft"] = isDraft;
      }

      if ($top !== undefined) {
        localVarQueryParameter["$top"] = $top;
      }

      if ($skip !== undefined) {
        localVarQueryParameter["$skip"] = $skip;
      }

      if ($filter !== undefined) {
        localVarQueryParameter["$filter"] = $filter;
      }

      if ($orderby !== undefined) {
        localVarQueryParameter["$orderby"] = $orderby;
      }

      if ($expand !== undefined) {
        localVarQueryParameter["$expand"] = $expand;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} docEntry
     * @param {string} [$top] The max number of records. (e.g. $top&#x3D;10)
     * @param {string} [$skip] The number of records to skip. (e.g. $skip&#x3D;5)
     * @param {string} [$filter] A function that must evaluate to true for a record to be returned. (e.g. $filter&#x3D;CustomerName eq \&#39;bob\&#39;)
     * @param {string} [$orderby] Determines what values are used to order a collection of records. (e.g. $orderby&#x3D;Address1_Country,Address1_City desc)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiCreditMemoGetFileUriListDocEntryGet: async (
      docEntry: number,
      $top?: string,
      $skip?: string,
      $filter?: string,
      $orderby?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'docEntry' is not null or undefined
      assertParamExists(
        "apiCreditMemoGetFileUriListDocEntryGet",
        "docEntry",
        docEntry
      );
      const localVarPath = `/api/CreditMemo/GetFileUriList/{DocEntry}`.replace(
        `{${"DocEntry"}}`,
        encodeURIComponent(String(docEntry))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKeyAuth required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Api-Key",
        configuration
      );

      if ($top !== undefined) {
        localVarQueryParameter["$top"] = $top;
      }

      if ($skip !== undefined) {
        localVarQueryParameter["$skip"] = $skip;
      }

      if ($filter !== undefined) {
        localVarQueryParameter["$filter"] = $filter;
      }

      if ($orderby !== undefined) {
        localVarQueryParameter["$orderby"] = $orderby;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} docEntry
     * @param {boolean} [isDraft]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiCreditMemoGetFormIdDocEntryGet: async (
      docEntry: number,
      isDraft?: boolean,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'docEntry' is not null or undefined
      assertParamExists(
        "apiCreditMemoGetFormIdDocEntryGet",
        "docEntry",
        docEntry
      );
      const localVarPath = `/api/CreditMemo/GetFormId/{DocEntry}`.replace(
        `{${"DocEntry"}}`,
        encodeURIComponent(String(docEntry))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKeyAuth required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Api-Key",
        configuration
      );

      if (isDraft !== undefined) {
        localVarQueryParameter["IsDraft"] = isDraft;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary
     * @param {ApiCreditMemoDRAFTPatchRequest} [apiCreditMemoDRAFTPatchRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiCreditMemoPatch: async (
      apiCreditMemoDRAFTPatchRequest?: ApiCreditMemoDRAFTPatchRequest,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/CreditMemo`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PATCH",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKeyAuth required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Api-Key",
        configuration
      );

      localVarHeaderParameter["Content-Type"] =
        "application/json;odata.metadata=minimal;odata.streaming=true";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        apiCreditMemoDRAFTPatchRequest,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary
     * @param {ApiCreditMemoDRAFTPatchRequest} [apiCreditMemoDRAFTPatchRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiCreditMemoUpdatePost: async (
      apiCreditMemoDRAFTPatchRequest?: ApiCreditMemoDRAFTPatchRequest,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/CreditMemo/Update`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKeyAuth required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Api-Key",
        configuration
      );

      localVarHeaderParameter["Content-Type"] =
        "application/json;odata.metadata=minimal;odata.streaming=true";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        apiCreditMemoDRAFTPatchRequest,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get document by DocEntry and IsDraft
     * @param {number} docEntry
     * @param {boolean} [isDraft]
     * @param {string} [$expand] Specifies the related resources to be included in line with retrieved resources. (e.g. $expand&#x3D;DocumentLines)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    docEntryGet: async (
      docEntry: number,
      isDraft?: boolean,
      $expand?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'docEntry' is not null or undefined
      assertParamExists("docEntryGet", "docEntry", docEntry);
      const localVarPath = `/api/CreditMemo({DocEntry})`.replace(
        `{${"DocEntry"}}`,
        encodeURIComponent(String(docEntry))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication apiKeyAuth required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Api-Key",
        configuration
      );

      if (isDraft !== undefined) {
        localVarQueryParameter["IsDraft"] = isDraft;
      }

      if ($expand !== undefined) {
        localVarQueryParameter["$expand"] = $expand;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * CreditMemoApi - functional programming interface
 * @export
 */
export const CreditMemoApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    CreditMemoApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Get document by DocEntry and IsDraft
     * @param {number} docEntry
     * @param {string} dRAFT
     * @param {boolean} [isDraft]
     * @param {string} [$expand] Specifies the related resources to be included in line with retrieved resources. (e.g. $expand&#x3D;DocumentLines)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiCreditMemoDRAFTDocEntryGet(
      docEntry: number,
      dRAFT: string,
      isDraft?: boolean,
      $expand?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<CreditMemoModel>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiCreditMemoDRAFTDocEntryGet(
          docEntry,
          dRAFT,
          isDraft,
          $expand,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @summary Default action to acquire list of documents by IsDraft
     * @param {string} dRAFT
     * @param {boolean} [isDraft]
     * @param {string} [$top] The max number of records. (e.g. $top&#x3D;10)
     * @param {string} [$skip] The number of records to skip. (e.g. $skip&#x3D;5)
     * @param {string} [$filter] A function that must evaluate to true for a record to be returned. (e.g. $filter&#x3D;CustomerName eq \&#39;bob\&#39;)
     * @param {string} [$orderby] Determines what values are used to order a collection of records. (e.g. $orderby&#x3D;Address1_Country,Address1_City desc)
     * @param {string} [$expand] Specifies the related resources to be included in line with retrieved resources. (e.g. $expand&#x3D;DocumentLines)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiCreditMemoDRAFTGet(
      dRAFT: string,
      isDraft?: boolean,
      $top?: string,
      $skip?: string,
      $filter?: string,
      $orderby?: string,
      $expand?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<CreditMemoModelODataResultCollection>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiCreditMemoDRAFTGet(
          dRAFT,
          isDraft,
          $top,
          $skip,
          $filter,
          $orderby,
          $expand,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @param {number} docEntry
     * @param {string} dRAFT
     * @param {boolean} [isDraft]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiCreditMemoDRAFTGetFormIdDocEntryGet(
      docEntry: number,
      dRAFT: string,
      isDraft?: boolean,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiCreditMemoDRAFTGetFormIdDocEntryGet(
          docEntry,
          dRAFT,
          isDraft,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @summary
     * @param {string} dRAFT
     * @param {ApiCreditMemoDRAFTPatchRequest} [apiCreditMemoDRAFTPatchRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiCreditMemoDRAFTPatch(
      dRAFT: string,
      apiCreditMemoDRAFTPatchRequest?: ApiCreditMemoDRAFTPatchRequest,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<CreditMemoModel>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiCreditMemoDRAFTPatch(
          dRAFT,
          apiCreditMemoDRAFTPatchRequest,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @summary
     * @param {string} dRAFT
     * @param {ApiCreditMemoDRAFTPatchRequest} [apiCreditMemoDRAFTPatchRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiCreditMemoDRAFTUpdatePost(
      dRAFT: string,
      apiCreditMemoDRAFTPatchRequest?: ApiCreditMemoDRAFTPatchRequest,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<CreditMemoModel>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiCreditMemoDRAFTUpdatePost(
          dRAFT,
          apiCreditMemoDRAFTPatchRequest,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @summary Get document by DocEntry and IsDraft
     * @param {number} docEntry
     * @param {boolean} [isDraft]
     * @param {string} [$expand] Specifies the related resources to be included in line with retrieved resources. (e.g. $expand&#x3D;DocumentLines)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiCreditMemoDocEntryGet(
      docEntry: number,
      isDraft?: boolean,
      $expand?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<CreditMemoModel>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiCreditMemoDocEntryGet(
          docEntry,
          isDraft,
          $expand,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @summary Default action to acquire list of documents by IsDraft
     * @param {boolean} [isDraft]
     * @param {string} [$top] The max number of records. (e.g. $top&#x3D;10)
     * @param {string} [$skip] The number of records to skip. (e.g. $skip&#x3D;5)
     * @param {string} [$filter] A function that must evaluate to true for a record to be returned. (e.g. $filter&#x3D;CustomerName eq \&#39;bob\&#39;)
     * @param {string} [$orderby] Determines what values are used to order a collection of records. (e.g. $orderby&#x3D;Address1_Country,Address1_City desc)
     * @param {string} [$expand] Specifies the related resources to be included in line with retrieved resources. (e.g. $expand&#x3D;DocumentLines)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiCreditMemoGet(
      isDraft?: boolean,
      $top?: string,
      $skip?: string,
      $filter?: string,
      $orderby?: string,
      $expand?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<CreditMemoModelODataResultCollection>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiCreditMemoGet(
          isDraft,
          $top,
          $skip,
          $filter,
          $orderby,
          $expand,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @param {number} docEntry
     * @param {string} [$top] The max number of records. (e.g. $top&#x3D;10)
     * @param {string} [$skip] The number of records to skip. (e.g. $skip&#x3D;5)
     * @param {string} [$filter] A function that must evaluate to true for a record to be returned. (e.g. $filter&#x3D;CustomerName eq \&#39;bob\&#39;)
     * @param {string} [$orderby] Determines what values are used to order a collection of records. (e.g. $orderby&#x3D;Address1_Country,Address1_City desc)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiCreditMemoGetFileUriListDocEntryGet(
      docEntry: number,
      $top?: string,
      $skip?: string,
      $filter?: string,
      $orderby?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<FileUriODataResultCollection>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiCreditMemoGetFileUriListDocEntryGet(
          docEntry,
          $top,
          $skip,
          $filter,
          $orderby,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @param {number} docEntry
     * @param {boolean} [isDraft]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiCreditMemoGetFormIdDocEntryGet(
      docEntry: number,
      isDraft?: boolean,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiCreditMemoGetFormIdDocEntryGet(
          docEntry,
          isDraft,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @summary
     * @param {ApiCreditMemoDRAFTPatchRequest} [apiCreditMemoDRAFTPatchRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiCreditMemoPatch(
      apiCreditMemoDRAFTPatchRequest?: ApiCreditMemoDRAFTPatchRequest,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<CreditMemoModel>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiCreditMemoPatch(
          apiCreditMemoDRAFTPatchRequest,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @summary
     * @param {ApiCreditMemoDRAFTPatchRequest} [apiCreditMemoDRAFTPatchRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async apiCreditMemoUpdatePost(
      apiCreditMemoDRAFTPatchRequest?: ApiCreditMemoDRAFTPatchRequest,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<CreditMemoModel>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.apiCreditMemoUpdatePost(
          apiCreditMemoDRAFTPatchRequest,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @summary Get document by DocEntry and IsDraft
     * @param {number} docEntry
     * @param {boolean} [isDraft]
     * @param {string} [$expand] Specifies the related resources to be included in line with retrieved resources. (e.g. $expand&#x3D;DocumentLines)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async docEntryGet(
      docEntry: number,
      isDraft?: boolean,
      $expand?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<CreditMemoModel>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.docEntryGet(
        docEntry,
        isDraft,
        $expand,
        options
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
  };
};

/**
 * CreditMemoApi - factory interface
 * @export
 */
export const CreditMemoApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = CreditMemoApiFp(configuration);
  return {
    /**
     *
     * @summary Get document by DocEntry and IsDraft
     * @param {CreditMemoApiApiCreditMemoDRAFTDocEntryGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiCreditMemoDRAFTDocEntryGet(
      requestParameters: CreditMemoApiApiCreditMemoDRAFTDocEntryGetRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<CreditMemoModel> {
      return localVarFp
        .apiCreditMemoDRAFTDocEntryGet(
          requestParameters.docEntry,
          requestParameters.dRAFT,
          requestParameters.isDraft,
          requestParameters.$expand,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Default action to acquire list of documents by IsDraft
     * @param {CreditMemoApiApiCreditMemoDRAFTGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiCreditMemoDRAFTGet(
      requestParameters: CreditMemoApiApiCreditMemoDRAFTGetRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<CreditMemoModelODataResultCollection> {
      return localVarFp
        .apiCreditMemoDRAFTGet(
          requestParameters.dRAFT,
          requestParameters.isDraft,
          requestParameters.$top,
          requestParameters.$skip,
          requestParameters.$filter,
          requestParameters.$orderby,
          requestParameters.$expand,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {CreditMemoApiApiCreditMemoDRAFTGetFormIdDocEntryGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiCreditMemoDRAFTGetFormIdDocEntryGet(
      requestParameters: CreditMemoApiApiCreditMemoDRAFTGetFormIdDocEntryGetRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<number> {
      return localVarFp
        .apiCreditMemoDRAFTGetFormIdDocEntryGet(
          requestParameters.docEntry,
          requestParameters.dRAFT,
          requestParameters.isDraft,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary
     * @param {CreditMemoApiApiCreditMemoDRAFTPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiCreditMemoDRAFTPatch(
      requestParameters: CreditMemoApiApiCreditMemoDRAFTPatchRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<CreditMemoModel> {
      return localVarFp
        .apiCreditMemoDRAFTPatch(
          requestParameters.dRAFT,
          requestParameters.apiCreditMemoDRAFTPatchRequest,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary
     * @param {CreditMemoApiApiCreditMemoDRAFTUpdatePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiCreditMemoDRAFTUpdatePost(
      requestParameters: CreditMemoApiApiCreditMemoDRAFTUpdatePostRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<CreditMemoModel> {
      return localVarFp
        .apiCreditMemoDRAFTUpdatePost(
          requestParameters.dRAFT,
          requestParameters.apiCreditMemoDRAFTPatchRequest,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get document by DocEntry and IsDraft
     * @param {CreditMemoApiApiCreditMemoDocEntryGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiCreditMemoDocEntryGet(
      requestParameters: CreditMemoApiApiCreditMemoDocEntryGetRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<CreditMemoModel> {
      return localVarFp
        .apiCreditMemoDocEntryGet(
          requestParameters.docEntry,
          requestParameters.isDraft,
          requestParameters.$expand,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Default action to acquire list of documents by IsDraft
     * @param {CreditMemoApiApiCreditMemoGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiCreditMemoGet(
      requestParameters: CreditMemoApiApiCreditMemoGetRequest = {},
      options?: AxiosRequestConfig
    ): AxiosPromise<CreditMemoModelODataResultCollection> {
      return localVarFp
        .apiCreditMemoGet(
          requestParameters.isDraft,
          requestParameters.$top,
          requestParameters.$skip,
          requestParameters.$filter,
          requestParameters.$orderby,
          requestParameters.$expand,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {CreditMemoApiApiCreditMemoGetFileUriListDocEntryGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiCreditMemoGetFileUriListDocEntryGet(
      requestParameters: CreditMemoApiApiCreditMemoGetFileUriListDocEntryGetRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<FileUriODataResultCollection> {
      return localVarFp
        .apiCreditMemoGetFileUriListDocEntryGet(
          requestParameters.docEntry,
          requestParameters.$top,
          requestParameters.$skip,
          requestParameters.$filter,
          requestParameters.$orderby,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {CreditMemoApiApiCreditMemoGetFormIdDocEntryGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiCreditMemoGetFormIdDocEntryGet(
      requestParameters: CreditMemoApiApiCreditMemoGetFormIdDocEntryGetRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<number> {
      return localVarFp
        .apiCreditMemoGetFormIdDocEntryGet(
          requestParameters.docEntry,
          requestParameters.isDraft,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary
     * @param {CreditMemoApiApiCreditMemoPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiCreditMemoPatch(
      requestParameters: CreditMemoApiApiCreditMemoPatchRequest = {},
      options?: AxiosRequestConfig
    ): AxiosPromise<CreditMemoModel> {
      return localVarFp
        .apiCreditMemoPatch(
          requestParameters.apiCreditMemoDRAFTPatchRequest,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary
     * @param {CreditMemoApiApiCreditMemoUpdatePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiCreditMemoUpdatePost(
      requestParameters: CreditMemoApiApiCreditMemoUpdatePostRequest = {},
      options?: AxiosRequestConfig
    ): AxiosPromise<CreditMemoModel> {
      return localVarFp
        .apiCreditMemoUpdatePost(
          requestParameters.apiCreditMemoDRAFTPatchRequest,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get document by DocEntry and IsDraft
     * @param {CreditMemoApiDocEntryGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    docEntryGet(
      requestParameters: CreditMemoApiDocEntryGetRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<CreditMemoModel> {
      return localVarFp
        .docEntryGet(
          requestParameters.docEntry,
          requestParameters.isDraft,
          requestParameters.$expand,
          options
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * Request parameters for apiCreditMemoDRAFTDocEntryGet operation in CreditMemoApi.
 * @export
 * @interface CreditMemoApiApiCreditMemoDRAFTDocEntryGetRequest
 */
export interface CreditMemoApiApiCreditMemoDRAFTDocEntryGetRequest {
  /**
   *
   * @type {number}
   * @memberof CreditMemoApiApiCreditMemoDRAFTDocEntryGet
   */
  readonly docEntry: number;

  /**
   *
   * @type {string}
   * @memberof CreditMemoApiApiCreditMemoDRAFTDocEntryGet
   */
  readonly dRAFT: string;

  /**
   *
   * @type {boolean}
   * @memberof CreditMemoApiApiCreditMemoDRAFTDocEntryGet
   */
  readonly isDraft?: boolean;

  /**
   * Specifies the related resources to be included in line with retrieved resources. (e.g. $expand&#x3D;DocumentLines)
   * @type {string}
   * @memberof CreditMemoApiApiCreditMemoDRAFTDocEntryGet
   */
  readonly $expand?: string;
}

/**
 * Request parameters for apiCreditMemoDRAFTGet operation in CreditMemoApi.
 * @export
 * @interface CreditMemoApiApiCreditMemoDRAFTGetRequest
 */
export interface CreditMemoApiApiCreditMemoDRAFTGetRequest {
  /**
   *
   * @type {string}
   * @memberof CreditMemoApiApiCreditMemoDRAFTGet
   */
  readonly dRAFT: string;

  /**
   *
   * @type {boolean}
   * @memberof CreditMemoApiApiCreditMemoDRAFTGet
   */
  readonly isDraft?: boolean;

  /**
   * The max number of records. (e.g. $top&#x3D;10)
   * @type {string}
   * @memberof CreditMemoApiApiCreditMemoDRAFTGet
   */
  readonly $top?: string;

  /**
   * The number of records to skip. (e.g. $skip&#x3D;5)
   * @type {string}
   * @memberof CreditMemoApiApiCreditMemoDRAFTGet
   */
  readonly $skip?: string;

  /**
   * A function that must evaluate to true for a record to be returned. (e.g. $filter&#x3D;CustomerName eq \&#39;bob\&#39;)
   * @type {string}
   * @memberof CreditMemoApiApiCreditMemoDRAFTGet
   */
  readonly $filter?: string;

  /**
   * Determines what values are used to order a collection of records. (e.g. $orderby&#x3D;Address1_Country,Address1_City desc)
   * @type {string}
   * @memberof CreditMemoApiApiCreditMemoDRAFTGet
   */
  readonly $orderby?: string;

  /**
   * Specifies the related resources to be included in line with retrieved resources. (e.g. $expand&#x3D;DocumentLines)
   * @type {string}
   * @memberof CreditMemoApiApiCreditMemoDRAFTGet
   */
  readonly $expand?: string;
}

/**
 * Request parameters for apiCreditMemoDRAFTGetFormIdDocEntryGet operation in CreditMemoApi.
 * @export
 * @interface CreditMemoApiApiCreditMemoDRAFTGetFormIdDocEntryGetRequest
 */
export interface CreditMemoApiApiCreditMemoDRAFTGetFormIdDocEntryGetRequest {
  /**
   *
   * @type {number}
   * @memberof CreditMemoApiApiCreditMemoDRAFTGetFormIdDocEntryGet
   */
  readonly docEntry: number;

  /**
   *
   * @type {string}
   * @memberof CreditMemoApiApiCreditMemoDRAFTGetFormIdDocEntryGet
   */
  readonly dRAFT: string;

  /**
   *
   * @type {boolean}
   * @memberof CreditMemoApiApiCreditMemoDRAFTGetFormIdDocEntryGet
   */
  readonly isDraft?: boolean;
}

/**
 * Request parameters for apiCreditMemoDRAFTPatch operation in CreditMemoApi.
 * @export
 * @interface CreditMemoApiApiCreditMemoDRAFTPatchRequest
 */
export interface CreditMemoApiApiCreditMemoDRAFTPatchRequest {
  /**
   *
   * @type {string}
   * @memberof CreditMemoApiApiCreditMemoDRAFTPatch
   */
  readonly dRAFT: string;

  /**
   *
   * @type {ApiCreditMemoDRAFTPatchRequest}
   * @memberof CreditMemoApiApiCreditMemoDRAFTPatch
   */
  readonly apiCreditMemoDRAFTPatchRequest?: ApiCreditMemoDRAFTPatchRequest;
}

/**
 * Request parameters for apiCreditMemoDRAFTUpdatePost operation in CreditMemoApi.
 * @export
 * @interface CreditMemoApiApiCreditMemoDRAFTUpdatePostRequest
 */
export interface CreditMemoApiApiCreditMemoDRAFTUpdatePostRequest {
  /**
   *
   * @type {string}
   * @memberof CreditMemoApiApiCreditMemoDRAFTUpdatePost
   */
  readonly dRAFT: string;

  /**
   *
   * @type {ApiCreditMemoDRAFTPatchRequest}
   * @memberof CreditMemoApiApiCreditMemoDRAFTUpdatePost
   */
  readonly apiCreditMemoDRAFTPatchRequest?: ApiCreditMemoDRAFTPatchRequest;
}

/**
 * Request parameters for apiCreditMemoDocEntryGet operation in CreditMemoApi.
 * @export
 * @interface CreditMemoApiApiCreditMemoDocEntryGetRequest
 */
export interface CreditMemoApiApiCreditMemoDocEntryGetRequest {
  /**
   *
   * @type {number}
   * @memberof CreditMemoApiApiCreditMemoDocEntryGet
   */
  readonly docEntry: number;

  /**
   *
   * @type {boolean}
   * @memberof CreditMemoApiApiCreditMemoDocEntryGet
   */
  readonly isDraft?: boolean;

  /**
   * Specifies the related resources to be included in line with retrieved resources. (e.g. $expand&#x3D;DocumentLines)
   * @type {string}
   * @memberof CreditMemoApiApiCreditMemoDocEntryGet
   */
  readonly $expand?: string;
}

/**
 * Request parameters for apiCreditMemoGet operation in CreditMemoApi.
 * @export
 * @interface CreditMemoApiApiCreditMemoGetRequest
 */
export interface CreditMemoApiApiCreditMemoGetRequest {
  /**
   *
   * @type {boolean}
   * @memberof CreditMemoApiApiCreditMemoGet
   */
  readonly isDraft?: boolean;

  /**
   * The max number of records. (e.g. $top&#x3D;10)
   * @type {string}
   * @memberof CreditMemoApiApiCreditMemoGet
   */
  readonly $top?: string;

  /**
   * The number of records to skip. (e.g. $skip&#x3D;5)
   * @type {string}
   * @memberof CreditMemoApiApiCreditMemoGet
   */
  readonly $skip?: string;

  /**
   * A function that must evaluate to true for a record to be returned. (e.g. $filter&#x3D;CustomerName eq \&#39;bob\&#39;)
   * @type {string}
   * @memberof CreditMemoApiApiCreditMemoGet
   */
  readonly $filter?: string;

  /**
   * Determines what values are used to order a collection of records. (e.g. $orderby&#x3D;Address1_Country,Address1_City desc)
   * @type {string}
   * @memberof CreditMemoApiApiCreditMemoGet
   */
  readonly $orderby?: string;

  /**
   * Specifies the related resources to be included in line with retrieved resources. (e.g. $expand&#x3D;DocumentLines)
   * @type {string}
   * @memberof CreditMemoApiApiCreditMemoGet
   */
  readonly $expand?: string;
}

/**
 * Request parameters for apiCreditMemoGetFileUriListDocEntryGet operation in CreditMemoApi.
 * @export
 * @interface CreditMemoApiApiCreditMemoGetFileUriListDocEntryGetRequest
 */
export interface CreditMemoApiApiCreditMemoGetFileUriListDocEntryGetRequest {
  /**
   *
   * @type {number}
   * @memberof CreditMemoApiApiCreditMemoGetFileUriListDocEntryGet
   */
  readonly docEntry: number;

  /**
   * The max number of records. (e.g. $top&#x3D;10)
   * @type {string}
   * @memberof CreditMemoApiApiCreditMemoGetFileUriListDocEntryGet
   */
  readonly $top?: string;

  /**
   * The number of records to skip. (e.g. $skip&#x3D;5)
   * @type {string}
   * @memberof CreditMemoApiApiCreditMemoGetFileUriListDocEntryGet
   */
  readonly $skip?: string;

  /**
   * A function that must evaluate to true for a record to be returned. (e.g. $filter&#x3D;CustomerName eq \&#39;bob\&#39;)
   * @type {string}
   * @memberof CreditMemoApiApiCreditMemoGetFileUriListDocEntryGet
   */
  readonly $filter?: string;

  /**
   * Determines what values are used to order a collection of records. (e.g. $orderby&#x3D;Address1_Country,Address1_City desc)
   * @type {string}
   * @memberof CreditMemoApiApiCreditMemoGetFileUriListDocEntryGet
   */
  readonly $orderby?: string;
}

/**
 * Request parameters for apiCreditMemoGetFormIdDocEntryGet operation in CreditMemoApi.
 * @export
 * @interface CreditMemoApiApiCreditMemoGetFormIdDocEntryGetRequest
 */
export interface CreditMemoApiApiCreditMemoGetFormIdDocEntryGetRequest {
  /**
   *
   * @type {number}
   * @memberof CreditMemoApiApiCreditMemoGetFormIdDocEntryGet
   */
  readonly docEntry: number;

  /**
   *
   * @type {boolean}
   * @memberof CreditMemoApiApiCreditMemoGetFormIdDocEntryGet
   */
  readonly isDraft?: boolean;
}

/**
 * Request parameters for apiCreditMemoPatch operation in CreditMemoApi.
 * @export
 * @interface CreditMemoApiApiCreditMemoPatchRequest
 */
export interface CreditMemoApiApiCreditMemoPatchRequest {
  /**
   *
   * @type {ApiCreditMemoDRAFTPatchRequest}
   * @memberof CreditMemoApiApiCreditMemoPatch
   */
  readonly apiCreditMemoDRAFTPatchRequest?: ApiCreditMemoDRAFTPatchRequest;
}

/**
 * Request parameters for apiCreditMemoUpdatePost operation in CreditMemoApi.
 * @export
 * @interface CreditMemoApiApiCreditMemoUpdatePostRequest
 */
export interface CreditMemoApiApiCreditMemoUpdatePostRequest {
  /**
   *
   * @type {ApiCreditMemoDRAFTPatchRequest}
   * @memberof CreditMemoApiApiCreditMemoUpdatePost
   */
  readonly apiCreditMemoDRAFTPatchRequest?: ApiCreditMemoDRAFTPatchRequest;
}

/**
 * Request parameters for docEntryGet operation in CreditMemoApi.
 * @export
 * @interface CreditMemoApiDocEntryGetRequest
 */
export interface CreditMemoApiDocEntryGetRequest {
  /**
   *
   * @type {number}
   * @memberof CreditMemoApiDocEntryGet
   */
  readonly docEntry: number;

  /**
   *
   * @type {boolean}
   * @memberof CreditMemoApiDocEntryGet
   */
  readonly isDraft?: boolean;

  /**
   * Specifies the related resources to be included in line with retrieved resources. (e.g. $expand&#x3D;DocumentLines)
   * @type {string}
   * @memberof CreditMemoApiDocEntryGet
   */
  readonly $expand?: string;
}

/**
 * CreditMemoApi - object-oriented interface
 * @export
 * @class CreditMemoApi
 * @extends {BaseAPI}
 */
export class CreditMemoApi extends BaseAPI {
  /**
   *
   * @summary Get document by DocEntry and IsDraft
   * @param {CreditMemoApiApiCreditMemoDRAFTDocEntryGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CreditMemoApi
   */
  public apiCreditMemoDRAFTDocEntryGet(
    requestParameters: CreditMemoApiApiCreditMemoDRAFTDocEntryGetRequest,
    options?: AxiosRequestConfig
  ) {
    return CreditMemoApiFp(this.configuration)
      .apiCreditMemoDRAFTDocEntryGet(
        requestParameters.docEntry,
        requestParameters.dRAFT,
        requestParameters.isDraft,
        requestParameters.$expand,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Default action to acquire list of documents by IsDraft
   * @param {CreditMemoApiApiCreditMemoDRAFTGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CreditMemoApi
   */
  public apiCreditMemoDRAFTGet(
    requestParameters: CreditMemoApiApiCreditMemoDRAFTGetRequest,
    options?: AxiosRequestConfig
  ) {
    return CreditMemoApiFp(this.configuration)
      .apiCreditMemoDRAFTGet(
        requestParameters.dRAFT,
        requestParameters.isDraft,
        requestParameters.$top,
        requestParameters.$skip,
        requestParameters.$filter,
        requestParameters.$orderby,
        requestParameters.$expand,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {CreditMemoApiApiCreditMemoDRAFTGetFormIdDocEntryGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CreditMemoApi
   */
  public apiCreditMemoDRAFTGetFormIdDocEntryGet(
    requestParameters: CreditMemoApiApiCreditMemoDRAFTGetFormIdDocEntryGetRequest,
    options?: AxiosRequestConfig
  ) {
    return CreditMemoApiFp(this.configuration)
      .apiCreditMemoDRAFTGetFormIdDocEntryGet(
        requestParameters.docEntry,
        requestParameters.dRAFT,
        requestParameters.isDraft,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary
   * @param {CreditMemoApiApiCreditMemoDRAFTPatchRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CreditMemoApi
   */
  public apiCreditMemoDRAFTPatch(
    requestParameters: CreditMemoApiApiCreditMemoDRAFTPatchRequest,
    options?: AxiosRequestConfig
  ) {
    return CreditMemoApiFp(this.configuration)
      .apiCreditMemoDRAFTPatch(
        requestParameters.dRAFT,
        requestParameters.apiCreditMemoDRAFTPatchRequest,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary
   * @param {CreditMemoApiApiCreditMemoDRAFTUpdatePostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CreditMemoApi
   */
  public apiCreditMemoDRAFTUpdatePost(
    requestParameters: CreditMemoApiApiCreditMemoDRAFTUpdatePostRequest,
    options?: AxiosRequestConfig
  ) {
    return CreditMemoApiFp(this.configuration)
      .apiCreditMemoDRAFTUpdatePost(
        requestParameters.dRAFT,
        requestParameters.apiCreditMemoDRAFTPatchRequest,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get document by DocEntry and IsDraft
   * @param {CreditMemoApiApiCreditMemoDocEntryGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CreditMemoApi
   */
  public apiCreditMemoDocEntryGet(
    requestParameters: CreditMemoApiApiCreditMemoDocEntryGetRequest,
    options?: AxiosRequestConfig
  ) {
    return CreditMemoApiFp(this.configuration)
      .apiCreditMemoDocEntryGet(
        requestParameters.docEntry,
        requestParameters.isDraft,
        requestParameters.$expand,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Default action to acquire list of documents by IsDraft
   * @param {CreditMemoApiApiCreditMemoGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CreditMemoApi
   */
  public apiCreditMemoGet(
    requestParameters: CreditMemoApiApiCreditMemoGetRequest = {},
    options?: AxiosRequestConfig
  ) {
    return CreditMemoApiFp(this.configuration)
      .apiCreditMemoGet(
        requestParameters.isDraft,
        requestParameters.$top,
        requestParameters.$skip,
        requestParameters.$filter,
        requestParameters.$orderby,
        requestParameters.$expand,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {CreditMemoApiApiCreditMemoGetFileUriListDocEntryGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CreditMemoApi
   */
  public apiCreditMemoGetFileUriListDocEntryGet(
    requestParameters: CreditMemoApiApiCreditMemoGetFileUriListDocEntryGetRequest,
    options?: AxiosRequestConfig
  ) {
    return CreditMemoApiFp(this.configuration)
      .apiCreditMemoGetFileUriListDocEntryGet(
        requestParameters.docEntry,
        requestParameters.$top,
        requestParameters.$skip,
        requestParameters.$filter,
        requestParameters.$orderby,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {CreditMemoApiApiCreditMemoGetFormIdDocEntryGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CreditMemoApi
   */
  public apiCreditMemoGetFormIdDocEntryGet(
    requestParameters: CreditMemoApiApiCreditMemoGetFormIdDocEntryGetRequest,
    options?: AxiosRequestConfig
  ) {
    return CreditMemoApiFp(this.configuration)
      .apiCreditMemoGetFormIdDocEntryGet(
        requestParameters.docEntry,
        requestParameters.isDraft,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary
   * @param {CreditMemoApiApiCreditMemoPatchRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CreditMemoApi
   */
  public apiCreditMemoPatch(
    requestParameters: CreditMemoApiApiCreditMemoPatchRequest = {},
    options?: AxiosRequestConfig
  ) {
    return CreditMemoApiFp(this.configuration)
      .apiCreditMemoPatch(
        requestParameters.apiCreditMemoDRAFTPatchRequest,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary
   * @param {CreditMemoApiApiCreditMemoUpdatePostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CreditMemoApi
   */
  public apiCreditMemoUpdatePost(
    requestParameters: CreditMemoApiApiCreditMemoUpdatePostRequest = {},
    options?: AxiosRequestConfig
  ) {
    return CreditMemoApiFp(this.configuration)
      .apiCreditMemoUpdatePost(
        requestParameters.apiCreditMemoDRAFTPatchRequest,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get document by DocEntry and IsDraft
   * @param {CreditMemoApiDocEntryGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CreditMemoApi
   */
  public docEntryGet(
    requestParameters: CreditMemoApiDocEntryGetRequest,
    options?: AxiosRequestConfig
  ) {
    return CreditMemoApiFp(this.configuration)
      .docEntryGet(
        requestParameters.docEntry,
        requestParameters.isDraft,
        requestParameters.$expand,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
}
